module.exports = __webpack_public_path__ + "img/care-offer-1.7becef23.jpg";